import { useState, useEffect } from 'react';
import { fetchData, organizeScores } from '../utils/scoreUtils';

const useScoreData = (year) => {
  const [scoreData, setScoreData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);
      const rawData = await fetchData(year);
      if (rawData) {
        const organizedData = organizeScores(rawData);
        setScoreData(organizedData);
      }
      setLoading(false);
    };
    loadData();
  }, [year]);

  return { scoreData, loading };
};

export default useScoreData;